// @ts-nocheck
//Smooth Scroll
import { Link } from 'react-scroll';

// レイアウト
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

// モーダル
import { useState } from 'react';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function F_office() {

  // モーダル
  const [showSeatmap1, setShowSeatmap1] = useState(false);

  const baseUrl = process.env.REACT_APP_PUBLIC_URL;

  return (
    <div className="facility-lower">
      <h2 className="tag-title">麻布台ヒルズ情報</h2>
      <div class="ruleBox">
        <div class="flowimg--box"></div><div class="point--box">
          <div class="box">
            <div class="head-box">
              <p>〒106-0041　東京都港区麻布台 1-3-1　麻布台ヒルズ 森JPタワー22F</p>
              <p>部署ごとの電話番号は<a href="https://www.ztree.cfbx.jp/info-wp/wp-content/uploads/2024/10/部門別＿新電話番号一覧-1.pdf" target='blank' className='text-link type-external'>こちら</a></p></div></div></div>
      </div>


      <Row>
        <Col sm={12}>
          <Row className='toc-btnArea'>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter10"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                Zenken麻布台ヒルズ<br />5つの活用ポイント
              </Link>
            </Col>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter01"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                フロアマップ
              </Link>
            </Col>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter02"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                会議室（22階）
              </Link>
            </Col>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter03"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                22階のこと
              </Link>
            </Col>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter04"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                電話について
              </Link>
            </Col>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter05"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                複合機について
              </Link>
            </Col>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter06"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                入退館方法／<br />セキュリティ開始解除方法
              </Link>
            </Col>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter07"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                Hills Houseについて
              </Link>
            </Col>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter08"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                来客対応について
              </Link>
            </Col>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter11"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                清掃・水やり当番
              </Link>
            </Col>
            <Col sm={4} className='toc-btn px-1'>
              <Link
                to="chapter09"
                smooth={true}
                duration={500}
                offset={-100}
                className='btn main-btn type-internal w-100'
              >
                その他
              </Link>
            </Col>
          </Row>
        </Col>
      </Row>
      <section className="sec-office">
        <h3 id="chapter10" className='icon-title type-pencil'>Zenken麻布台ヒルズ5つの活用ポイント</h3>
        <iframe src="https://docs.google.com/presentation/d/1sbw2QbmVq1BSGZpcs5gpusnLqcQvDg8is5RdMWFW4WA/preview?slide=id.g31b56f3ce44_0_81"  width="860" height="520" allow="autoplay"></iframe>
        <h3 id="chapter01" className='icon-title type-pencil'>フロアマップ</h3>
        <iframe src="https://docs.google.com/presentation/d/1zhUKxYXwO8Lox1_c6VSv6sA2VsF89GKTQfoN-xNlgCs/preview?slide=id.p"  width="860" height="520" allow="autoplay"></iframe>
        <h3 id="chapter02" className='icon-title type-pencil'>会議室（22階）</h3>
        <iframe src="https://docs.google.com/presentation/d/1wzIxfVR3gddhBvGAMslpK5a66fZsA5zb4dPE1yUVAh0/preview?slide=id.p"  width="860" height="520" allow="autoplay"></iframe>
        <h3 id="chapter03" className='icon-title type-pencil'>22階のこと</h3>
        <iframe src="https://docs.google.com/presentation/d/1uAbc6Z5lRtIQLRP2Gfj2OXJjFgUxovQ5xDonIGx7Ksk/preview?slide=id.p"  width="860" height="520" allow="autoplay"></iframe>
        <h3 id="chapter04" className='icon-title type-pencil'>電話について</h3>
        <iframe src="https://docs.google.com/presentation/d/1W4VE-XLrQjAe52yR0RZQln1YTLDC_s-M3KiMZY-pV6I/preview?slide=id.p"  width="860" height="520" allow="autoplay"></iframe>
        <h3 id="chapter05" className='icon-title type-pencil'>複合機について</h3>
        <iframe src="https://docs.google.com/presentation/d/1Um-N80R472A1c20Z4sgds_6AXFq57lBxRG9-C3T1990/preview?slide=id.p"  width="860" height="520" allow="autoplay"></iframe>
        <h3 id="chapter06" className='icon-title type-pencil'>入退館方法／セキュリティ開始解除方法</h3>
        <iframe src="https://docs.google.com/presentation/d/1XcfLzmXVdc4QR_Uv-LU2Eunc-Lf0pdyt_FHrYewQ4_A/preview?slide=id.p"  width="860" height="520" allow="autoplay"></iframe>
        <h3 id="chapter07" className='icon-title type-pencil'>Hills Houseについて</h3>
        <iframe src="https://docs.google.com/presentation/d/1xXLnuIVaHHj8l3lWHcRlf4UXV0xiIiMmLGLbnXoQKU8/preview?slide=id.p"  width="860" height="520" allow="autoplay"></iframe>
        <h3 id="chapter08" className='icon-title type-pencil'>来客対応について</h3>
        <iframe src="https://docs.google.com/presentation/d/1xTC_kIvyYd6hOaL-4fFn_QoZWiqf6WqVQ2CEOhdRnAw/preview?slide=id.p"  width="860" height="520" allow="autoplay"></iframe>
        <h3 id="chapter11" className='icon-title type-pencil'>清掃・水やり当番</h3>
        <iframe src="https://docs.google.com/presentation/d/1AEXA5G2tJCADtISBpysQAaK6zTxgTZM61spJ_jJA2OM/preview?slide=id.p"  width="860" height="520" allow="autoplay"></iframe>
        <h3 id="chapter09" className='icon-title type-pencil'>その他</h3>
        <iframe src="https://docs.google.com/presentation/d/19Mu-K19iMCyje6D0Y3G6SoU-3G0OP-4iKTIXvbwEF48/preview?slide=id.p"  width="860" height="520" allow="autoplay"></iframe>
        <div class="activity-record">
          <h4 class="bg-title">関係アナウンス</h4>
          <ul>
            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3037">【重要】麻布台ヒルズ 本社Wi-Fi接続設定について（2024/11/25）</a></li>
            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3039">【重要】本店移転（麻布台ヒルズ）移転前確認事項”後編”のご案内（2024/11/22）</a></li>
            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2742">【重要】本店移転（麻布台ヒルズ）について概要のご案内（2024/11/11）</a></li>
            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2821">【重要】麻布台ヒルズ22Fの会議室予約と運用についてのご案内（2024/11/01）</a></li>
            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2879">麻布台ヒルズ移転後の新しい電話番号のご案内（2024/10/31）</a></li>
            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2791">麻布台ヒルズに関する作成動画のご案内（駅から麻布台ヒルズ等）（2024/10/25）</a></li>
          </ul>
        </div>
        <div class="activity-record">
          <h4 class="bg-title">関係ブログ</h4>
          <ul>
            <li><a href="https://www.ztree.cfbx.jp/board-voice?id=2568&default=1">12/20(金) UP 麻布台ヒルズ周辺ランチマップ②</a></li>
            <li><a href="https://www.ztree.cfbx.jp/deptBlog?id=1782&default=20">11/18(月) UP 新オフィス「麻布台ヒルズ」の魅力とお楽しみポイント♪＆「ECO SALE」予告</a></li>
            <li><a href="https://www.ztree.cfbx.jp/board-voice?id=2346&default=1">11/15(金) UP 麻布台ヒルズ周辺ランチマップ</a></li>
          </ul>
        </div>
      </section>
    </div>
  );
}
export default F_office;

